import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Symbol } from "../GameComponents/Symbol";
import { Symbols } from "../GameComponents/Symbols";
import { WinAnimatorExtended } from "./WinAnimatorExtended";
import { SymbolExtended } from "./SymbolExtended";

var PickRoundSpotStatus = Communication.Game.PickRoundSpotStatus;
var PickRoundSpotValueType = Communication.Game.PickRoundSpotValueType;

/**
 * WinAnimatorPick uses paylines and symbols to create presentation of wins to user.
 * Also handle high wins animation for presentation special screens to user when win is bigger than some defined values.
 * @class WinAnimatorPick
 * @extends ContainerElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorPick extends WinAnimatorExtended {
    initialize(symbols: Symbols, symbolsContainer?: ContainerElement): void {
        this.createSymbols(symbols, null, symbolsContainer);
    }

    showSymbols(reelsData: Array<Communication.Game.IReel>) {
        if (reelsData) {
            this.currentReels = reelsData;

            if (this.currentSymbols.length == 0) {
                for (let i = 0; i < this.currentReels.length; i++) {
                    this.currentSymbols.push([]);

                    for (let j = 0; j < this.currentReels[i].symbols.length; j++) {
                        this.currentSymbols[i].push(null);
                    }
                }
            }

            // return all previous symbols
            for (let i = 0; i < this.currentSymbols.length; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    this.removeCurrentSymbol(i, j);
                }

                // fix symbols array length (old vs new length)
                if (this.currentSymbols[i] && this.currentSymbols[i].length != this.currentReels[i].symbols.length) {
                    if (this.currentSymbols[i].length < this.currentReels[i].symbols.length) {
                        for (let k = this.currentSymbols[i].length; k < this.currentReels[i].symbols.length; k++) {
                            this.currentSymbols[i].push(null);
                        }
                    } else {
                        while (this.currentSymbols[i].length > this.currentReels[i].symbols.length) {
                            this.currentSymbols[i].pop();
                        }
                    }
                }
            }

            for (let i = 0; i < this.currentReels.length; i++) {
                for (let j = this.currentReels[i].symbols.length - 1; j >= 0; j--) {
                    this.addCurrentSymbol(i, j);
                }
            }
        }
    }

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
            const id = this.currentReels[reelIndex].symbols[symbolIndex];

            let symbolsLength: number = this.symbolCount[reelIndex];
            let dataSymbolsLength: number = this.currentReels[reelIndex].symbols.length;
            let symbolSizeY: number =
                dataSymbolsLength > 0 ? (symbolsLength * this.symbolHeight) / dataSymbolsLength : this.symbolHeight;
            let symbolCase: string = Symbol.CaseNormal;

            const symbol = this.symbols.getSymbol(id - 1, symbolCase);

            let symbolCountCase: string;

            if (this.reelsHorizontalIndexes.indexOf(reelIndex) != -1) {
                symbol.position.x = this.reelX[reelIndex] + this.symbolWidth * symbolIndex - symbol.offsetX;
                symbol.position.y = this.reelY[reelIndex] - symbol.offsetY;

                symbolCountCase = SymbolExtended.CaseCount + "_5";
                symbol.symbolCountOnReel = 5;
            } else {
                symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
                symbol.position.y = this.reelY[reelIndex] + symbolSizeY * symbolIndex - symbol.offsetY;

                symbolCountCase = SymbolExtended.CaseCount + "_" + dataSymbolsLength;
                symbol.symbolCountOnReel = dataSymbolsLength;
            }

            this.currentSymbols[reelIndex][symbolIndex] = symbol;

            symbol.goToCase(symbolCountCase); // for init size symbol, after this call basic CASE like NORMAL
            symbol.goToCase(symbolCase);

            this.symbolsContainer.addChild(symbol); // add to win container
        }
    }
}

export const WinAnimatorPickAttributes = {};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorPick.ts
 **/